import { render, staticRenderFns } from "./barcode.vue?vue&type=template&id=3c37c504&scoped=true"
import script from "./barcode.vue?vue&type=script&lang=js"
export * from "./barcode.vue?vue&type=script&lang=js"
import style0 from "./barcode.vue?vue&type=style&index=0&id=3c37c504&prod&scoped=true&lang=css"
import style1 from "./barcode.vue?vue&type=style&index=1&id=3c37c504&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c37c504",
  null
  
)

export default component.exports